import { IsInt, IsString, IsOptional } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class NominalReportingDto extends BaseDto{
    @IsString()
    code: string;

    @IsString()
    accountingName: string;

    @IsOptional()
    @IsString()
    type?: string;

    @IsOptional()
    @IsString()
    description?: string;

    @IsOptional()
    @IsInt()
    merchantGroupId?: number;

    @IsOptional()
    @IsInt()
    countryId?: number;

    @IsOptional()
    merchantGroup?: MerchantGroupDto;
}
